import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { User } from 'firebase/auth';

interface MenuComponentProps {
  user: User | null;
  handleNavigation: (view: 'login' | 'settings' | 'daily') => void;
}

const MenuComponent: React.FC<MenuComponentProps> = ({
  user,
  handleNavigation,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      alert('Signed out successfully');
      handleNavigation('login');
      handleMenuClose();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleMenuItemClick = (view: 'login' | 'settings' | 'daily') => {
    handleNavigation(view);
    handleMenuClose();
  };

  return (
    <AppBar position='static'>
      <Toolbar>
        <IconButton
          edge='start'
          color='inherit'
          aria-label='menu'
          onClick={handleMenuOpen}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant='h6' style={{ flexGrow: 1 }}>
          Avalon Bible Plan
        </Typography>
      </Toolbar>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {!user && (
          <MenuItem onClick={() => handleMenuItemClick('login')}>
            Login
          </MenuItem>
        )}
        {user && (
          <>
            <MenuItem onClick={() => handleMenuItemClick('daily')}>
              Daily Reading
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick('settings')}>
              Settings
            </MenuItem>
            <MenuItem onClick={handleSignOut}>Logout</MenuItem>
          </>
        )}
      </Menu>
    </AppBar>
  );
};

export default MenuComponent;
